import React, { useState } from 'react';
import { FiPercent } from 'react-icons/fi';
import styles from './Emitir.module.css';

/* 1ª nota do mês de cliente do Simples: confirmar a alíquota do mês.
   Não tem fechar -- só segue escolhendo uma das duas opções (pedido do
   usuário: não pode sair sem confirmar). */
const mesAno = (c) => (c ? `${c.slice(5)}/${c.slice(0, 4)}` : '');

function ModalAliquotaMes({ mes, ultima, onConfirmar }) {
  const [nova, setNova] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  async function confirmar(aliquota, mantida) {
    setSalvando(true); setErro('');
    try { await onConfirmar(aliquota, mantida); } catch (e) { setErro(e.message); setSalvando(false); }
  }
  const valorNova = Number(String(nova).replace(',', '.'));
  return (
    <div className={styles.modalFundo || ''} style={{ position: 'fixed', inset: 0, background: 'rgba(13,31,60,0.45)', zIndex: 1200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div role="dialog" aria-modal="true" style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', width: 'min(460px, 100%)', boxShadow: '0 20px 50px rgba(13,31,60,0.3)' }}>
        <h3 style={{ margin: '0 0 4px', display: 'flex', alignItems: 'center', gap: 8, fontSize: 16, color: '#0D1F3C' }}><FiPercent /> Alíquota do Simples de {mesAno(mes)}</h3>
        <p style={{ margin: '0 0 14px', fontSize: 13, color: '#4b5d73' }}>É a primeira nota deste mês. Confirme a alíquota antes de emitir — ela fica registrada no histórico do cliente.</p>
        {ultima && (
          <button type="button" disabled={salvando} onClick={() => confirmar(ultima.aliquota, true)}
            style={{ width: '100%', textAlign: 'left', border: '1px solid #c9dcf3', background: '#f4f8fd', borderRadius: 10, padding: '10px 12px', marginBottom: 10, cursor: 'pointer', fontSize: 13.5 }}>
            Manter a última: <strong>{ultima.aliquota}%</strong> <span style={{ color: '#6B8CAE' }}>({mesAno(ultima.competencia)})</span>
          </button>
        )}
        <div style={{ border: '1px solid #e4edf5', borderRadius: 10, padding: '10px 12px' }}>
          <span style={{ fontSize: 13.5 }}>Informar a alíquota nova</span>
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <input type="number" step="0.01" min="0" autoFocus value={nova} onChange={e => setNova(e.target.value)} placeholder="ex.: 6,54"
              style={{ flex: 1, height: 36, border: '1px solid #d7e3ef', borderRadius: 8, padding: '0 10px', fontSize: 14 }} />
            <button type="button" disabled={salvando || nova === '' || !(valorNova >= 0)} onClick={() => confirmar(valorNova, false)}
              style={{ height: 36, padding: '0 14px', borderRadius: 8, border: '1px solid #0D1F3C', background: '#0D1F3C', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
              {salvando ? 'Salvando...' : 'Registrar e emitir'}
            </button>
          </div>
        </div>
        {erro && <p style={{ color: '#b91c1c', fontSize: 12.5, marginTop: 8 }}>{erro}</p>}
      </div>
    </div>
  );
}

export default ModalAliquotaMes;
